import { render, staticRenderFns } from "./TzggcxForm.vue?vue&type=template&id=4c7f6029&scoped=true"
import script from "./TzggcxForm.vue?vue&type=script&lang=js"
export * from "./TzggcxForm.vue?vue&type=script&lang=js"
import style0 from "./TzggcxForm.vue?vue&type=style&index=0&id=4c7f6029&prod&lang=scss&scoped=true"
import style1 from "./TzggcxForm.vue?vue&type=style&index=1&id=4c7f6029&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f6029",
  null
  
)

export default component.exports